module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2dda78968aae655c392d15281578a682.gif";